import { render } from "./beacon.vue?vue&type=template&id=396a0bfe&scoped=true"
import script from "./beacon.vue?vue&type=script&lang=js"
export * from "./beacon.vue?vue&type=script&lang=js"

import "./beacon.vue?vue&type=style&index=0&id=396a0bfe&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396a0bfe"]])

export default __exports__